import {
  INFORMATION_ALL,
  INFORMATION_ERROR,
  INFORMATION_LOADING,
  INFORMATION_PUT,
} from '../../actions/types';

const initialState = {
  information: null,
  isLoading: true,
  isCompleted: true,
};
// eslint-disable-next-line func-names
export default function (state = initialState, action) {
  switch (action.type) {
    case INFORMATION_LOADING:
      return { isLoading: true, isCompleted: true, name: 'E-Manufac' };
    case INFORMATION_ERROR:
      return {
        isLoading: false,
        isCompleted: false,
        name: 'E-Manufac',
        ...action.payload,
      };
    case INFORMATION_ALL:
      return {
        ...action.payload,
        isLoading: false,
        isCompleted: true,
      };
    case INFORMATION_PUT:
      return { isLoading: false, isCompleted: true, name: 'E-Manufac' };
    default:
      return state;
  }
}
